"use strict";function padNumber(e){return e="00"+e,e.substring(e.length-2,e.length)}Object.defineProperty(exports,"__esModule",{value:!0}),exports.log=function(e){console.log.apply(console,[padNumber(e.time.getHours())+":"+padNumber(e.time.getMinutes())+":"+padNumber(e.time.getSeconds())].concat(e.text))};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/lib/log.js
// module id = hAjJ
// module chunks = 23